import type { ApiRoutes } from '@tempo-io/integration-credentials-app/rpc';
import { createHonoRpcClient } from './hono-rpc-client';

export const getIntegrationCredentialsMergeDevApi = createHonoRpcClient<ApiRoutes>(
  '/api/integration-credentials/v1/merge-dev/',
);
